var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSwapArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0,-20)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 32,
    r: 11.5,
    fill: "white",
    stroke: "#ECECEC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 29.6C5.77909 29.6 5.6 29.7791 5.6 30C5.6 30.2209 5.77909 30.4 6 30.4L6 29.6ZM18.2828 30.2828C18.4391 30.1266 18.4391 29.8734 18.2828 29.7172L15.7373 27.1716C15.581 27.0154 15.3278 27.0154 15.1716 27.1716C15.0154 27.3278 15.0154 27.581 15.1716 27.7373L17.4343 30L15.1716 32.2627C15.0154 32.419 15.0154 32.6722 15.1716 32.8284C15.3278 32.9846 15.581 32.9846 15.7373 32.8284L18.2828 30.2828ZM6 30.4L18 30.4L18 29.6L6 29.6L6 30.4Z",
    fill: "#CD1919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 35.4C18.2209 35.4 18.4 35.2209 18.4 35C18.4 34.7791 18.2209 34.6 18 34.6L18 35.4ZM5.71716 34.7172C5.56095 34.8734 5.56095 35.1266 5.71716 35.2828L8.26274 37.8284C8.41895 37.9846 8.67222 37.9846 8.82843 37.8284C8.98464 37.6722 8.98464 37.419 8.82843 37.2627L6.56569 35L8.82843 32.7373C8.98464 32.581 8.98464 32.3278 8.82843 32.1716C8.67222 32.0154 8.41895 32.0154 8.26274 32.1716L5.71716 34.7172ZM18 34.6L6 34.6L6 35.4L18 35.4L18 34.6Z",
    fill: "#CD1919"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwapArrows);
export default __webpack_public_path__ + "static/media/swap-arrows.10fcf6a4931e9d436a08215e16d423db.svg";
export { ForwardRef as ReactComponent };